import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container", "emptyState"]

  add(event) {
    event.preventDefault()

    // Hide empty state if it exists
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.add('hidden')
    }

    // Get template content
    const content = this.templateTarget.content.cloneNode(true)

    // Get the next available index
    const nextIndex = this.getNextIndex()
    let newContent = '';
    Array.from(content.children).forEach(child => {
      newContent += child.outerHTML.replace(/NEW_RECORD/g, nextIndex);
    })

    // Add the new item to the container
    this.containerTarget.insertAdjacentHTML('beforeend', newContent)

    // Focus on the account number field
    const accountNumberField = this.containerTarget.lastElementChild.querySelector("input[name*='account_number']")
    if (accountNumberField) {
      accountNumberField.focus()
    }
  }

  getNextIndex() {
    // Get all existing bank account inputs
    const inputs = document.querySelectorAll('input[name*="[bank_accounts_attributes]"]')
    let maxIndex = -1

    // Find the highest index currently in use
    inputs.forEach(input => {
      const match = input.name.match(/\[bank_accounts_attributes\]\[(\d+)\]/)
      if (match) {
        const index = parseInt(match[1])
        maxIndex = Math.max(maxIndex, index)
      }
    })

    return maxIndex + 1
  }
}